import moment from 'moment';
import { Button } from 'semantic-ui-react';
import { agGridDateCreatedAtFieldComparator } from '../../table/helpers';
import {
  kindOfGroups,
  kindOfSeminaries,
} from '../../../containers/groups/newLeaders/newLeadersQuestions';

const GROUP_TYPES = new Set(kindOfGroups.map((kind) => kind.value));
const SEMINARY_TYPES = new Set(kindOfSeminaries.map((kind) => kind.value));

export const NEW_LEADER_CATEGORY_FILTER_COL = 'applicationCategory';

export const getNewLeaderCategoryLabel = (type) => {
  if (GROUP_TYPES.has(type)) return 'Grupo';
  if (SEMINARY_TYPES.has(type)) return 'Seminario';
  return '';
};

export const NewLeadersRowDef = ({ set_showNewLeaderForm, loading }) => {
  return [
    {
      headerName: 'Formulario',
      children: [
        {
          headerName: 'Fecha',
          width: 140,
          field: 'createdAt',
          valueGetter: (params) =>
            moment.tz(params?.data?.createdAt, 'America/Bogota').format('DD-MM-YYYY'),
          comparator: agGridDateCreatedAtFieldComparator,
        },
        {
          headerName: 'Categoría',
          colId: NEW_LEADER_CATEGORY_FILTER_COL,
          width: 120,
          valueGetter: (params) => getNewLeaderCategoryLabel(params?.data?.type),
          filterValueGetter: (params) => getNewLeaderCategoryLabel(params?.data?.type),
        },
        {
          headerName: 'Tipo',
          width: 160,
          field: 'type',
          valueGetter: (params) =>
            params?.data?.info?.info_couple_seminary ??
            [...kindOfGroups, ...kindOfSeminaries]?.find(
              (kind) => kind.value === params?.data?.type
            )?.text,
        },
      ],
    },
    {
      headerName: 'Datos aspirantes',
      children: [
        {
          headerName: 'Nombre El',
          width: 160,
          field: 'his_name',
          valueGetter: (params) =>
            `${params?.data?.maleNewLeader?.name || ''} ${
              params?.data?.maleNewLeader?.lastName || ''
            }`,
        },
        {
          headerName: 'Nombre Ella',
          width: 160,
          field: 'her_name',
          valueGetter: (params) =>
            `${params?.data?.femaleNewLeader?.name || ''} ${
              params?.data?.femaleNewLeader?.lastName || ''
            }`,
        },
      ],
    },
    {
      headerName: 'Acciones',
      children: [
        {
          headerName: 'Autorizado por el líder',
          width: 180,
          field: 'survey',
          valueGetter: (params) => {
            if (typeof params?.data?.survey !== 'boolean') return 'Pendiente';
            return params.data.survey ? 'Si' : 'No';
          },
        },
        {
          headerName: 'Ver',
          field: 'actions',
          width: 135,
          sortable: false,
          filter: false,
          cellRenderer: (params) => (
            <Button
              size="tiny"
              disabled={loading}
              onClick={() => set_showNewLeaderForm(params?.data?.id)}
            >
              Ver
            </Button>
          ),
        },
      ],
    },
  ];
};
